import React from 'react';
import './Onboarding.css'; 

const EXPERIENCE_LEVELS = [
    { label: 'Beginner', value: 'beginner', description: 'I have little to no experience in this field.' },
    { label: 'Intermediate', value: 'intermediate', description: 'I have basic skills and knowledge; ready for deeper learning.' },
    { label: 'Advanced', value: 'advanced', description: 'I am proficient and looking for expert-level training and resources.' },
];

const StepExperience = ({ value, onChange }) => {
  return (
    <div className="experience-input">
      <p className="input-prompt">This helps us gauge the complexity of the resources we recommend.</p>
      <div className="experience-options-grid">
        {EXPERIENCE_LEVELS.map((level) => (
          <button
            key={level.value}
            className={`btn-tertiary experience-btn ${value === level.value ? 'selected' : ''}`}
            onClick={() => onChange(level.value)}
          >
            <div className="experience-label">{level.label}</div>
            <div className="experience-description">{level.description}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default StepExperience;
